
import { useParams } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import TermsOfService from './TermsOfService';
import PrivacyPolicy from './PrivacyPolicy';
import CookiePolicy from './CookiePolicy';
import Imprint from './Imprint';

const Legal = () => {
  const { docType } = useParams<{ docType: string }>();

  // Render the appropriate legal document based on the URL parameter
  const renderLegalContent = () => {
    switch (docType) {
      case 'terms':
        return <TermsOfService />;
      case 'privacy':
        return <PrivacyPolicy />;
      case 'cookie-policy':
        return <CookiePolicy />;
      case 'imprint':
        return <Imprint />;
      default:
        return <TermsOfService />;
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow container mx-auto px-4 py-10 mt-16">
        {renderLegalContent()}
      </main>
      <Footer />
    </div>
  );
};

export default Legal;
